import React, { useEffect, useState } from "react"
import { IconButton, Grid } from "@material-ui/core"
import moment from "moment"
import { useHistory, useLocation } from "react-router-dom"

import EditTaggedDateIcon from "../icons/EditTaggedDateIcon"
import { useSelector } from "react-redux"
import { TAGGED_DATE_FORMAT } from "../../utils"

function ViewerTaggedDate(props) {
	const location = useLocation()
	const history = useHistory()

	const { taggedDateData } = useSelector((state) => state.taggedDateReducers)

	const [currTaggedDate, setCurrTaggedDate] = useState(props?.data?.tagged_date)

	useEffect(() => {
		if (taggedDateData?.reqData?.taggedDate) {
			setCurrTaggedDate(taggedDateData?.reqData?.taggedDate)
		}
	}, [taggedDateData])

	return (
		<Grid container spacing={1}>
			<Grid item xs={11}>
				{moment.utc(currTaggedDate).local().format(TAGGED_DATE_FORMAT)}
			</Grid>
			<Grid item xs={1}>
				<IconButton
					onClick={() => {
						const path = location?.pathname?.split("/")
						props?.dialogData?.setTaggedDateDialogOpen(true)
						props?.dialogData?.setTagDatedDialogData({
							...props?.data,
							id: path[3],
							tagged_date: currTaggedDate,
						})
					}}
					style={{ padding: 0 }}
				>
					<EditTaggedDateIcon style={{ marginTop: -4 }} />
				</IconButton>
			</Grid>
		</Grid>
	)
}

export default ViewerTaggedDate
